import React from "react";
import {SearchResultTableWithUpdateUI} from "../Common/SearchResultTableWithUpdateUI";
import {View} from "../GenGenPlate/Enum";
import {gppApiConsts} from "./GppApiConsts";
import {GppTableDataApi} from "./GppTableDataApi";
import {InHouseCellLineForm} from "./InHouseCellLineForm";

interface EngineCellLineSearchResultTableState {}

interface EngineCellLineSearchResultTableProps {
    keywords: string
    comparator: string
    refreshToken: string
    view: View
}

export class InHouseCellLineSearchResultTable extends React.Component<EngineCellLineSearchResultTableProps, EngineCellLineSearchResultTableState> {
    static defaultProps = {
        refreshToken: "",
        keywords: "",
    }

    render() {
        return <SearchResultTableWithUpdateUI
            refreshToken={this.props.refreshToken}
            databaseName={gppApiConsts.DATABASE_NAME}
            tableName={"in_house_cell_line"}
            keywords={this.props.keywords}
            columns={""}
            operator={this.props.comparator}
            keyField={"id"}
            legends={<></>}
            title={this.props.view === View.Update ?  "" : "In-house Cell Lines"}
            modalForm={InHouseCellLineForm}
            rowClasses={() => "table-light"}
            columnsHidden={["id"]}
            columnsDisplayInOrder={[
                "cellLine", "vendor", "cas9Version", "availabilityOfInHouseCas9Lines","availabilityOfInHouseCrisprEditedKnockoutLines", "crisprEditedGeneKnockoutLinesGenerated", 
                "availabilityOfInHouseRnpLines", "rnpEditedGeneKnockoutLinesGenerated", "additionalNote", "basalMedia", "fbsPercentage", "sodiumPyruvatePercentage", 
                "antibioticsAntimycoticsPercentage", "lGlutaminePercentage", "neaaPercentage", "otherMedia", "purchaseDate", "annualLicenseFee", "cellAuthentication", 
                "cellAuthenticationDate", "owner"
            ]}
            view={this.props.view}
            enableFilter={this.props.view === View.Update}
            searchTable={GppTableDataApi.searchTable}
        />
    }
}